import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import FileAttach from "../../../../../../images/Attachments.svg";
import Input from "../../../../../../stories/Input/Input";
import { useLazyQuery, useMutation } from "@apollo/client";
import { Junction } from "../../../masters/subsidary/junctions/queries/types";
import {
  nodeVar,
  OrderDirection,
} from "../../../../../../utils/commonQueryTypes";
import {
  AtsTicketsByNodeForStatus,
  GetItemsDetails,
  GetTicketDetailsForFollowUp,
  JunctionsNode,
} from "../../../masters/items/queries/queries";
import PoleNumComponent from "../../../../../common/Autocomplete/PoleNumComponent";
import {
  emptyFunc,
  emptyMessage,
  FETCH_MORE_DATA,
  ROWS_PER_PAGE,
  TicketStatus,
} from "../../../../../../utils/constants";
import { ResolveTypes } from "../../../maps/ticketing/history/AddFollowUpStatus";
import { Title } from "../../../../../../stories/Title/Title";
import Close from "../../../../../../images/Close.svg";
import { Button } from "../../../../../../stories/Button/Button";
import {
  AddTicketDetailsResult,
  AddTicketDetailsVariables,
  AtsStckItemDetailsEdges,
  AtsStckItemDetailsOrderField,
  DeviceTypes,
  GetItemsDetailsResult,
  GetItemsDetailsVars,
  ItemDetailsQueryType,
  TicketAssetsInput,
} from "../../../masters/items/queries/types";
import useUrlParams from "../../../../../../customHooks/useUrlParams";
import { Checkbox } from "@mui/material";
import Info from "../../../../../../images/Info.svg";
import documentImage from "../../../../../../images/DownloadImage.svg";
import { CustomDrawer } from "../../../../../../styles/CustomDrawerStyles";
import { AppContext } from "../../../../../../context/context";
import { payloadTypes } from "../../../../../../context/reducer";
import ViewAssetDetails from "../../../maps/ticketing/raisedtickets/ViewAssetDetails";
import { Operation, PageFor } from "../../../../../../utils/Enum.types";
import useLoggedInUserDetails from "../../../../../../customHooks/useLoggedInUserDetails";
import useServerDateandTime from "../../../../../../customHooks/useServerDateandTime";
import useToken from "../../../../../../customHooks/useToken";
import MessageModal from "../../../../../../customComponents/MessageModal";
import { AddTicketDetails } from "../../../masters/items/queries/mutations";
import { handleUploadAndDownloadFile } from "../../../../../../utils/Upload";
import { AtsTicketDetails } from "../../../maps/queries/types";
import { MapsContext } from "../../../maps/context/context";
import { CustomModal } from "../../../../../../utils/UtilFunctions";
import { ImageModalStylesInTickets } from "../../../../../../styles/CustomModalStyles";
import DownloadImage from "../../../../../../images/DownloadImage.svg";
import { ticketDetailsByNodeId } from "../../../maps/queries/queriers";
import { getDownloadUrl } from "../../../../../../utils/DownloadFile";
import { GetTickets } from "../../../../../../queries/queries";
import {
  AtsTicketsOrderField,
  TicketsQueryType,
} from "../../../../../../queries/types";
import {
  GetDashboardJunctionCount,
  GetDashboardTicketCount,
} from "../queries";
import DeviceTypesSelect from "../../../../../../customComponents/DeviceTypesSelect";
import { Label } from "../../../../../../stories/Label/Label";
interface Props {
  setDrawerFlag: React.Dispatch<React.SetStateAction<ResolveTypes>>;
  vendorId: number;
  junctionId: number;
  ticketId: number;
  pageType: PageFor;
  companyId: number;
  includeDeviceType?: boolean;
}

export interface selectedItemsType extends TicketAssetsInput {
  file: File | null;
}
const ResolveDetails = ({
  setDrawerFlag,
  vendorId,
  junctionId,
  ticketId,
  pageType,
  companyId,
  includeDeviceType
}: Props) => {
  const { customer_id } = useUrlParams();
  const { user_details } = useLoggedInUserDetails();
  const { handleToken } = useToken();
  const { state, dispatch } = useContext(AppContext);
  const { serverDate } = useServerDateandTime();
  const [poleNum, setPoleNum] = useState<number | null>(null);
  const [hasNextPage, setHasNextPage] = useState<boolean>(true);
  const [endCursor, setEndCursor] = useState<string | null>(null);
  const [itemDetails, setItemDetails] = useState<AtsStckItemDetailsEdges[]>([]);
  const [deviceTypes, setDeviceTypes] = useState<DeviceTypes[]>([]);
  const [deviceType, setDeviceType] = useState<DeviceTypes>({
    deviceTypeID: 0,
    deviceName: "",
    numOfUnits: 0,
  });

  const [remark, setRemark] = useState("");
  const [message, setMessage] = useState(emptyMessage);
  const { state: mapsContext } = useContext(MapsContext);

  const [previewImage, setPreviewImage] = useState("");

  const [imageModal, setImageModal] = useState(false);

  const [progress, setProgress] = useState(0);

  const value = useRef("");

  const [file, setFile] = useState<File | null>(null);
  const [searchData, setSearchData] = useState("");
  const [assetDetailsModal, setAssetDetailsModal] = useState(false);
  const [selectedItems, setSelectedItems] = useState<selectedItemsType[]>([]);

  const [GetTicktNode, { data: ticketNode }] = useLazyQuery<
    { node: AtsTicketDetails },
    nodeVar
  >(ticketDetailsByNodeId);

  const [getJunctionByNode, { data: junctionData }] = useLazyQuery<
    { node: Junction },
    nodeVar
  >(JunctionsNode);

  useEffect(() => {
    if (junctionId) {
      getJunctionByNode({
        variables: {
          id: junctionId,
        },
      });
    }
  }, [getJunctionByNode, junctionId]);

  const [GetJunctionItems, { data, fetchMore, loading }] = useLazyQuery<
    GetItemsDetailsResult,
    GetItemsDetailsVars
  >(GetItemsDetails);
  useEffect(() => {
    if (customer_id && pageType === PageFor.GENERAL) {
      GetJunctionItems({
        variables: {
          customerID: customer_id ? customer_id : 0,
          companyID: 0,
          subsidiaryID: 0,
          junctionID: junctionId,
          siteID: 0,
          input: {
            query_type: ItemDetailsQueryType.ALL,
            stckCategoryID: 0,
            stckGroupID: 0,
            stckManufacturerID: 0,
            stckUomID: 0,
            stckSubCategoryID: 0,
            itemID: 0,
            ldgrID: vendorId,
            poleNum,
            empID: user_details.id,
          },
          after: null,
          first: ROWS_PER_PAGE,
          name: searchData,
          orderBy: {
            direction: OrderDirection.ASC,
            field: AtsStckItemDetailsOrderField.CREATED_AT,
          },
        },
      });
    }
  }, [
    customer_id,
    GetJunctionItems,
    poleNum,
    junctionId,
    vendorId,
    searchData,
    pageType,
    user_details.id,
  ]);

  useEffect(() => {
    if (mapsContext.ticketDetailsId) {
      GetTicktNode({
        variables: {
          id: mapsContext.ticketDetailsId,
        },
      }).then(async ({ data }) => {
        if (data && data.node) {
          setRemark(data.node.remarks);
        }
      });
    }
  }, [GetTicktNode, mapsContext.ticketDetailsId]);

  const [addTicket] = useMutation<
    AddTicketDetailsResult,
    AddTicketDetailsVariables
  >(AddTicketDetails, {
    onError: (e) =>
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      }),
  });

  const hanldeMainImagePreview = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      setFile(e.target.files[0]);
    }
    e.target.value = "";
  };
  const handleImagePreview = (
    e: React.ChangeEvent<HTMLInputElement>,
    itemId: number
  ) => {
    if (e.target.files && e.target.files.length > 0) {
      const newFile = e.target.files[0];

      setSelectedItems((prev) => {
        const filtered = prev.filter((f) => f.itemDetailsID !== itemId);

        const newData: selectedItemsType = {
          file: newFile,
          anyChanges: "",
          AnySparesChanged: "",
          itemDetailsID: itemId,
          remarks: remark,
          imagesPath: "",
        };
        return [...filtered, newData];
      });
    }
    e.target.value = "";
  };

  const handleSubmit = async () => {
    try {
      const token = await handleToken();

      const itemsWithoutFiles = selectedItems.filter((si) => si.file);

      // if (file === null && itemsWithoutFiles.length === 0) {
      //   setMessage({
      //     flag: true,
      //     message: "Attachment is required",
      //     operation: Operation.NONE,
      //   });
      //   return;
      // } else {
      const ext = file?.name.split(".").pop();
      const name = file?.name.split(".")[0];
      const filename = `${companyId}/ticketDetails/${name}_0.${ext}`;

      // if (selectedItems.length) {
      if (token && customer_id) {
        const assetDetails: TicketAssetsInput[] = selectedItems.length
          ? selectedItems.map((si) => {
              const itemImageExt = si.file?.name.split(".").pop();
              const fileName = si.file?.name.split(".")[0];

              return {
                itemDetailsID: si.itemDetailsID,
                anyChanges: si.anyChanges,
                AnySparesChanged: si.AnySparesChanged,
                remarks: si.remarks,
                imagesPath: si.file
                  ? `${companyId}/ticketDetails/itemDetails/${fileName}.${itemImageExt}`
                  : "",
              };
            })
          : [];

        addTicket({
          variables: {
            token,
            todaysDate: serverDate,
            customerID: customer_id,
            ticketID: ticketId,
            user_details,
            deviceTypes: deviceTypes ? deviceTypes : [],
            input: {
              status: TicketStatus.RESOLVED,
              remarks: remark,
              imagesPath: file ? filename : "",
              assignedID: 0,
            },
            assetDetails,
          },
          refetchQueries: [
            {
              query: AtsTicketsByNodeForStatus,
              variables: {
                customerID: customer_id ? customer_id : 0,
                empID: user_details.id ? user_details.id : 0,
              },
            },
            {
              query: GetDashboardJunctionCount,
              variables: {
                customerID: customer_id ? customer_id : 0,
                empID: user_details.id ? user_details.id : 0,
              },
            },
            {
              query: AtsTicketsByNodeForStatus,
              variables: {
                id: mapsContext.ticketId,
              },
            },
            {
              query: GetTicketDetailsForFollowUp,
              variables: {
                customerID: customer_id!,
                ticketID: ticketId,
              },
            },
            {
              query: GetTickets,
              variables: {
                after: null,
                first: ROWS_PER_PAGE,
                name: searchData,
                deviceTypes: [],
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: AtsTicketsOrderField.TICKET_NO,
                },
                companyID: 0,
                customerID: customer_id,
                subsidiaryID: 0,
                junctionID: 0,
                reason: "",
                startDate: undefined,
                endDate: undefined,
                input: {
                  itemID: 0,
                  ldgrID: 0,
                  stckCategoryID: 0,
                  stckGroupID: 0,
                  stckManufacturerID: 0,
                  stckSubCategoryID: 0,
                  stckUomID: 0,
                  query_type: TicketsQueryType.ALL,
                  itemDetailsID: 0,
                  status: [TicketStatus.RESOLVED],
                  priority: [],
                  empID: user_details.id!,
                },
                siteID: 0,
              },
            },
            {
              query: GetDashboardTicketCount,
              variables: {
                customerID: customer_id ? customer_id : 0,
                empID: user_details.id ? user_details.id : 0,
              },
            },
          ],
        }).then(({ data }) => {
          if (data && data.AddTicketDetails) {
            const files = file;
            const uploadFilePromise = Promise.all([
              ...selectedItems.map((f, index) => {
                const fileExt = f.file?.name.split(".").pop();

                return handleUploadAndDownloadFile(
                  f.file!,
                  `${companyId}/ticketDetails/${data.AddTicketDetails.id}/itemDetails/${f.itemDetailsID}_0.${fileExt}`,
                  setProgress,
                  false
                );
              }),
              file &&
                handleUploadAndDownloadFile(
                  file,
                  // file.length > 1
                  //   ? `${companyId}/ticketDetails/${
                  //       data.AddTicketDetails.id
                  //     }_${index}.${
                  //       f.name.split(".")[f.name.split(".").length - 1]
                  //     }`
                  //   :

                  `${companyId}/ticketDetails/${data.AddTicketDetails.id}_0.${
                    file.name.split(".")[file.name.split(".").length - 1]
                  }`,
                  setProgress,
                  false
                ),
            ]);
            Promise.all([uploadFilePromise]).then(([sendMsgData]) => {
              if (sendMsgData) {
                setFile(null);
                setMessage({
                  flag: true,
                  message: "Added successfully",
                  operation: Operation.CREATE,
                });
              }
            });

            setSelectedItems([]);
          }
        });
      }
      // }
      //   else {
      //     setMessage({
      //       flag: true,
      //       message: `${ledgerLabel} is missing`,
      //       operation: Operation.NONE,
      //     });
      //   }
      // }
    } catch (err) {
      setMessage({
        flag: true,
        message: (err as Error).message,
        operation: Operation.NONE,
      });
    }
  };

  useEffect(() => {
    setRemark("");
    setFile(null);
    setItemDetails([]);
  }, []);

  const handleCheckboxChange = (item: {
    id: number;
    remarks: string;
    imagesPath?: string;
    anyChanges: string;
    anySparesChanged: string;
  }) => {
    setSelectedItems((prev) => {
      const exists = prev.find((i) => i.itemDetailsID === item.id);
      if (exists) {
        return prev.filter((i) => i.itemDetailsID !== item.id); // remove
      } else {
        return [
          ...prev,
          {
            itemDetailsID: item.id,
            anyChanges: item.anyChanges,
            AnySparesChanged: item.anySparesChanged,
            remarks: item.remarks || "",
            imagesPath: item.imagesPath || "",
            file: null,
          },
        ];
      }
    });
  };

  const handleClose = () => {
    setMessage(emptyMessage);
    if (message.operation !== Operation.NONE) {
      setDrawerFlag({
        flag: false,
        junctionId: 0,
        vendorId: 0,
      });
    }
  };

  const handleScroll = () => {
    if (hasNextPage && !loading) {
      fetchMore({
        variables: {
          first: FETCH_MORE_DATA,
          after: endCursor,
        },
        updateQuery: (prevResult, { fetchMoreResult }) => {
          if (!fetchMoreResult) return prevResult;

          const newEdges = fetchMoreResult.GetItemsDetails.edges;
          const pageInfo = fetchMoreResult.GetItemsDetails.pageInfo;

          setEndCursor(pageInfo.endCursor);
          setHasNextPage(pageInfo.hasNextPage);

          const duplicateCheck = prevResult.GetItemsDetails
            ? prevResult.GetItemsDetails.edges.filter(
                ({ node: { id } }) =>
                  newEdges.findIndex(
                    ({ node: { id: newId } }) => newId === id
                  ) !== -1
              )
            : [];

          if (duplicateCheck.length > 0) return prevResult;

          return {
            GetItemsDetails: {
              edges: [...itemDetails, ...newEdges],
              pageInfo,
              totalCount: data ? data.GetItemsDetails.totalCount! : 0,
            },
          };
        },
      });
    }
  };

  useEffect(() => {
    if (data && !loading) {
      const newData = data.GetItemsDetails.edges;

      if (endCursor) {
        const updatedNewData = newData.map((newCustomer) => {
          const filteredStudent = itemDetails.find(
            (ticket) => ticket.node.id === newCustomer.node.id
          );
          if (filteredStudent) {
            return {
              ...newCustomer,
              node: {
                ...newCustomer.node,
              },
            };
          }
          return newCustomer;
        });

        setItemDetails(updatedNewData);
      } else {
        setItemDetails(newData);
      }

      setEndCursor(data.GetItemsDetails.pageInfo.endCursor);
      setHasNextPage(data.GetItemsDetails.pageInfo.hasNextPage);
    } // eslint-disable-next-line
  }, [loading, data]);

  const disableSubmit = useMemo(() => {
    return (
      remark === "" ||
      selectedItems.filter((itm) => itm.remarks === "").length > 0
    );
  }, [selectedItems, remark]);

  const handleDeviceTypeChange = () => {
    if (!deviceType.deviceTypeID) return;

    setDeviceTypes((prev) => {
      const existingIndex = prev.findIndex(
        (d) => d.deviceTypeID === deviceType.deviceTypeID
      );

      if (existingIndex !== -1) {
        const updated = [...prev];
        updated[existingIndex] = {
          ...updated[existingIndex],
          numOfUnits: deviceType.numOfUnits,
        };
        return updated;
      } else {
        return [...prev, deviceType];
      }
    });

    setDeviceType({ deviceTypeID: 0, deviceName: "", numOfUnits: 0 });
  };

  return (
    <div className="resolve-details">
      <div className="resolve-details__title">
        <Title>Resolve Details</Title>
        <img
          src={Close}
          alt=""
          onClick={() =>
            setDrawerFlag({
              flag: false,
              vendorId: 0,
              junctionId: 0,
            })
          }
        />
      </div>
      <div className="resolve-details__input">
        <label className="resolve-details__input--user-input">
          <input
            type="text"
            placeholder="Type here..."
            id="file-name-display"
            autoFocus
            onChange={(e) => {
              value.current = e.target.value;
              setRemark(e.target.value);
            }}
            value={remark}
            disabled={pageType === PageFor.VIEW}
          />

          <img
            src={FileAttach}
            alt="Attach file"
            className="browse-icon"
            onClick={() => {
              const inputFile = document.getElementById("student-documents");

              if (inputFile) {
                inputFile?.click();
              }
            }}
          />

          <input
            id="student-documents"
            type="file"
            className="resolve-details__input--choose-file"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              hanldeMainImagePreview(e);
            }}
            disabled={pageType === PageFor.VIEW}
            // accept="image/jpg, image/png, image/jpeg"
          />
        </label>
      </div>

      {file || (ticketNode && ticketNode.node.imagesPath) ? (
        <div className="resolve-details__ul--comments--img">
          <img
            src={DownloadImage}
            alt=""
            className="junc-follow-up__data--remarks--flex--view"
            onClick={async () => {
              if (file) {
                setPreviewImage(URL.createObjectURL(file));
              }
              if (ticketNode && ticketNode.node.imagesPath) {
                const files = ticketNode.node.imagesPath.split(".");
                const ext = files.length ? files[files.length - 1] : "";
                const filename = `${ticketNode.node.companyID}/ticketDetails/${ticketNode.node.id}_0.${ext}`;
                const ers = await getDownloadUrl(filename, false);
                setPreviewImage(ers);
              }
              setImageModal(!imageModal);
            }}
          />
          {ticketNode ? ticketNode.node.imagesPath.split("/").pop() : ""}
        </div>
      ) : null}
      <div className="resolve-details__search row g-0">
        <div className="col">
          <Input
            id="data_search"
            placeholder="Search..."
            onChange={(e) => {
              setSearchData(e.target.value);
            }}
          />{" "}
        </div>
        <div className="col-4">
          {junctionData && junctionData.node.poles > 0 ? (
            <PoleNumComponent
              onChange={(newValue) => {
                setPoleNum(newValue);
              }}
              onKeyDown={emptyFunc}
              value={poleNum}
              label="Pole Number"
              poleNum={junctionData ? junctionData.node.poles : 0}
            />
          ) : null}
        </div>
        {includeDeviceType && (
          <>
            <div className="row">
              <div className="col-6">
                <Label>Device Types Select</Label>
              </div>
              <div className="col-6">
                {" "}
                <DeviceTypesSelect
                  label=""
                  onChange={(newValue) => {
                    if (newValue) {
                      setDeviceType({
                        ...deviceType,
                        deviceTypeID: newValue.value,
                        deviceName: newValue.label,
                      });
                    }
                  }}
                  onKeyDown={() => {}}
                  value={deviceType.deviceTypeID}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <Label>Number Of Units</Label>
              </div>
              <div className="col-6">
                <Input
                  placeholder="Number Of Units"
                  type="number"
                  value={deviceType.numOfUnits}
                  onChange={(e) => {
                    setDeviceType({
                      ...deviceType,
                      numOfUnits: Number(e.target.value),
                    });
                  }}
                />
              </div>
            </div>

            <Button
              onClick={() => {
                handleDeviceTypeChange();
              }}
            >
              +
            </Button>
            <div>
              <ul className="list-disc ml-5">
                {deviceTypes.map((d, index) => (
                  <li key={index}>
                    Device Type: {d.deviceName}, Units: {d.numOfUnits}
                  </li>
                ))}
              </ul>
            </div>
          </>
        )}
      </div>

      <div
        className={`resolve-details__ul${file ? "--file" : ""}`}
        onScroll={handleScroll}
      >
        {pageType === PageFor.GENERAL && data
          ? itemDetails.map((res, index) => {
              const img = require(`../../../../../../images/ItemIcons/${
                res.node.item.icon ? res.node.item.icon : "item"
              }.svg`);
              const isChecked = selectedItems.some(
                (item) => item.itemDetailsID === res.node.id
              );
              return (
                <li key={index}>
                  <div className="resolve-details__ul--li">
                    <div className="resolve-details__ul--flex">
                      {pageType === PageFor.GENERAL && (
                        <Checkbox
                          checked={isChecked}
                          onChange={() =>
                            handleCheckboxChange({
                              id: res.node.id,
                              remarks: "",
                              anyChanges: "",
                              anySparesChanged: "",
                              // imagesPath: file || file[0] || "",
                            })
                          }
                        />
                      )}

                      <img src={img} alt="" />
                      <div>
                        <b>{res.node.item.desc}</b>
                        <div className="resolve-details__ul--block">
                          <b className="font-blue">{res.node.item.slNo}</b>
                          <span className="font-grey">
                            {" "}
                            Pole {res.node.poleNum}
                          </span>
                        </div>
                      </div>
                    </div>
                    <img
                      src={Info}
                      alt=""
                      onClick={() => {
                        dispatch({
                          type: payloadTypes.SET_ITEM_DETAILS_ID,
                          payload: {
                            itemDetailsId: res.node.id,
                          },
                        });
                        setAssetDetailsModal(!assetDetailsModal);
                      }}
                    />
                  </div>
                  {isChecked && (
                    <div className="resolve-details__ul--comments">
                      <label className="resolve-details__input--user-input">
                        <input
                          type="text"
                          placeholder="Type here..."
                          id="file-name-display"
                          autoFocus
                          onChange={(e) => {
                            const updatedItems = selectedItems.map((si) =>
                              si.itemDetailsID === res.node.id
                                ? { ...si, remarks: e.target.value }
                                : si
                            );
                            setSelectedItems(updatedItems);
                          }}
                          value={
                            selectedItems.find(
                              (si) => si.itemDetailsID === res.node.id
                            )?.remarks || ""
                          }
                        />

                        <img
                          src={FileAttach}
                          alt="Attach file"
                          className="browse-icon"
                          onClick={() => {
                            const inputFile = document.getElementById(
                              `student-documents__browse--inputTag_${res.node.id}`
                            );
                            if (inputFile) {
                              inputFile.click();
                            }
                          }}
                        />
                        <input
                          id={`student-documents__browse--inputTag_${res.node.id}`}
                          type="file"
                          className="resolve-details__input--choose-file"
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            handleImagePreview(e, res.node.id);
                          }}
                          accept="image/jpg, image/png, image/jpeg"
                        />
                      </label>
                      {selectedItems.find(
                        (f) => f.itemDetailsID === res.node.id
                      ) &&
                        selectedItems.find(
                          (f) => f.itemDetailsID === res.node.id
                        )?.file && (
                          <div className="resolve-details__ul--comments--img">
                            <img
                              src={documentImage}
                              alt=""
                              onClick={() => {
                                const foundItem = selectedItems.find(
                                  (f) => f.itemDetailsID === res.node.id
                                );
                                if (foundItem && pageType === PageFor.GENERAL)
                                  setPreviewImage(
                                    URL.createObjectURL(foundItem.file!)
                                  );

                                setImageModal(!imageModal);
                              }}
                            />
                            <span>
                              {selectedItems.find(
                                (f) => f.itemDetailsID === res.node.id
                              )?.file?.name || ""}
                            </span>
                            <img
                              src={Close}
                              alt="Remove"
                              onClick={() => {
                                setSelectedItems((prev) =>
                                  prev.filter(
                                    (f) => f.itemDetailsID !== res.node.id
                                  )
                                );
                              }}
                            />
                          </div>
                        )}
                    </div>
                  )}
                </li>
              );
            })
          : pageType === PageFor.VIEW &&
            ticketNode &&
            ticketNode.node.ticketAssetDetails
          ? ticketNode.node.ticketAssetDetails.map((res, index) => {
              const img = require(`../../../../../../images/ItemIcons/${
                res.itemDetails.item.icon ? res.itemDetails.item.icon : "item"
              }.svg`);
              const imageName = `${res.images_path.split("/").pop()}`;

              return (
                <li key={index}>
                  <div className="resolve-details__ul--li">
                    <div className="resolve-details__ul--flex">
                      <img src={img} alt="" />
                      <div>
                        <b>{res.itemDetails.item.desc}</b>
                        <div className="resolve-details__ul--block">
                          <b className="font-blue">
                            {res.itemDetails.item.slNo}
                          </b>
                          <span className="font-grey">
                            {" "}
                            Pole {res.itemDetails.poleNum}
                          </span>
                        </div>
                      </div>
                    </div>
                    <img
                      src={Info}
                      alt=""
                      onClick={() => {
                        dispatch({
                          type: payloadTypes.SET_ITEM_DETAILS_ID,
                          payload: {
                            itemDetailsId: res.itemDetails.id,
                          },
                        });
                        setAssetDetailsModal(!assetDetailsModal);
                      }}
                    />
                  </div>
                  <div className="resolve-details__ul--comments">
                    <label className="resolve-details__input--user-input">
                      {res.remarks}
                      <img
                        src={FileAttach}
                        alt="Attach file"
                        className="browse-icon"
                        onClick={() => {
                          const inputFile = document.getElementById(
                            `student-documents__browse--inputTag_${res.itemDetails.id}`
                          );
                          if (inputFile) {
                            inputFile.click();
                          }
                        }}
                      />
                      <input
                        id={`student-documents__browse--inputTag_${res.itemDetails.id}`}
                        type="file"
                        className="resolve-details__input--choose-file"
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          handleImagePreview(e, res.itemDetails.id);
                        }}
                        accept="image/jpg, image/png, image/jpeg"
                      />
                    </label>

                    {res.images_path ? (
                      <div className="resolve-details__ul--comments--img">
                        <img
                          src={documentImage}
                          alt=""
                          onClick={async () => {
                            const ext = res.images_path.split(".").pop();
                            const filename = `${ticketNode.node.companyID}/ticketDetails/${ticketNode.node.id}/itemDetails/${res.itemDetails.id}_0.${ext}`;
                            const ers = await getDownloadUrl(filename, false);
                            setPreviewImage(ers);
                            setImageModal(!imageModal);
                          }}
                        />
                        <span>{imageName}</span>
                      </div>
                    ) : null}
                  </div>
                </li>
              );
            })
          : null}
      </div>
      <div className="row g-0">
        <div className="col-8">
          {pageType === PageFor.GENERAL && (
            <Button
              mode="save"
              onClick={handleSubmit}
              disabled={disableSubmit}
            />
          )}

          <Button
            mode="cancel"
            onClick={() =>
              setDrawerFlag({
                flag: false,
                vendorId: 0,
                junctionId: 0,
              })
            }
          />
        </div>
        <div className="col flex-end">
          <div className="overall-total-count">
            Total Assets <b>{data ? data.GetItemsDetails.totalCount : 0}</b>
          </div>
        </div>
      </div>

      <CustomDrawer
        anchor="right"
        open={assetDetailsModal}
        onClose={() => setAssetDetailsModal(!assetDetailsModal)}
      >
        <ViewAssetDetails
          setModalFlag={setAssetDetailsModal}
          itemId={state.itemDetailsId}
        />
      </CustomDrawer>
      <MessageModal
        handleClose={handleClose}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
      <CustomModal
        isOpen={imageModal}
        onRequestClose={() => setImageModal(!imageModal)}
        contentComponent={
          <>
            <div className="edit-vendor-response__title">
              <Title>Image details</Title>
              <img
                src={Close}
                alt=""
                onClick={() => setImageModal(!imageModal)}
              />
            </div>
            {previewImage && (
              <div
                className={`junc-follow-up__data--remarks--flex--image-container ${
                  previewImage ? "open" : ""
                }`}
              >
                <img
                  className="junc-follow-up__data--remarks--flex--image"
                  src={previewImage}
                  alt=""
                />
              </div>
            )}
          </>
        }
        style={ImageModalStylesInTickets}
      />
    </div>
  );
};

export default ResolveDetails;
